import React from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import Dashboard from "./page/dashboard/Dashboard.js";
import MainLayout from "./layout/main/MainLayout.js";
import Driver from "./page/driver/Driver.js";
import Login from "./page/login/Login.js";
import ProtectedRoute from "./utilities/auth/ProtectedRoute.js";
import { AuthProvider } from "./utilities/auth/auth.js";
import DailyRides from "./page/rides/daily/DailyRides.js";
import DriverDetails from "./page/driver/details/DriverDetails.js";
import RideDetails from "./page/rides/daily/SelectedRide/RideDetails.js";
import Payment from "./page/payment/Payment.js";
import Passenger from "./page/passenger/Passenger.js";
import Pricerating from "./page/Price rating/Pricerating.js";
import Zone from "./page/zone/Zone.js";
import Log from "./page/log/Log.js";
import BookingDetails from "./page/outstation/bookingDetails/BookingDetails.js";
import OnlineDriverslocation from "./page/onlineDrivers/OnlineDriverslocation.js";
import Zonemap from "./page/zone/Zonemap/Zonemap.js";
import Bookinglocations from "./page/blocation/Bookinglocations.js";
import { TotalDriverProvider } from "./page/onlineDrivers/totalOnlineContext.js";
import TopDrivers from "./page/TopDrivers/TopDrivers.js";
import Booking_outstation from "./page/outstation/Booking.js";
import Stats from "./page/rides/Statistics/Stats.js";
import DriverLocation from "./page/outstation/Driverlocation/DriverLocation.js";
import TourPackage from "./page/tourpackage/package/TourPackage.js";
import Operator from "./page/tourpackage/Operator/Operator.js";
import Empty from "./components/bar/Empty.js";
import SpecificOperator from "./page/tourpackage/Operator/specificOperator/SpecificOperator.js";
import AppBundle from "./page/appBundle/AppBundle.js";
import AppCreation from "./page/appBundle/AppCreation/AppCreation.js";
import Notifications from "./page/Notifications/Notifications.js";
import BulkBooking from "./page/bulk/Booking.js";
import BookingSingle from "./page/bulk/BulkbookingDetails.js";
import Request from "./page/rides/Request/RequestList.js";
import RequestList from "./page/rides/Request/RequestList.js";
// import TimePeriodChart from "./page/blocation/BookingTime.js";


function App() {

  return (
    <AuthProvider>
      <TotalDriverProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route element={<ProtectedRoute />}>
              <Route path="/" element={<MainLayout />}>
                <Route path="/" element={<Dashboard />} />
                <Route path="/dashboard" element={<Dashboard />} />
                <Route path="/rides/request" element={<RequestList />} />
                <Route path="/rides/today" element={<Stats />} />
                <Route path="/rides/daily" element={<DailyRides />} />
                <Route path="/rides/daily/details/:id" element={<RideDetails />} />
                <Route path="/drivers" element={<Driver />} />
                <Route path="/drivers/details/:id" element={<DriverDetails />} />
                <Route path="/passengers" element={<Passenger />} />
                <Route path="/zone/zones" element={<Zone />} />
                <Route path="/zone/zones/map" element={<Zonemap />} />
                {/* <Route path="/outstation/routes" element={<Empty />} /> */}
                <Route path="/outstation/bookings" element={<Booking_outstation />} />
                <Route path="/outstation/bookings/details/:id" element={<BookingDetails />} />
                <Route path="/finance/driver_fees" element={<Payment />} />
                <Route path="/finance/price" element={<Pricerating />} />
                <Route path="/system_maintenance" element={<TopDrivers />} />
                <Route path="/rides/map" element={<Bookinglocations />} />
                {/* <Route path="/rides/time" element={<TimePeriodChart />} /> */}

                <Route path="/tourism/package" element={<TourPackage />} />
                <Route path="/tourism/operator" element={<Operator />} />
                <Route path="/tourism/operator/:id" element={<SpecificOperator />} />

                <Route path="/outstation/driverlocation" element={<DriverLocation />} />
                <Route path="/bulkbooking" element={<BulkBooking />} />
                <Route path="/bulkbooking/details/:id" element={<BookingSingle />} />

                <Route path="/Driverslocation" element={<OnlineDriverslocation />} />
                <Route path="/appbundle" element={<AppBundle />} />
                <Route path="/notifications" element={<Notifications />} />
                {/* <Route path="/AppMain" element={<AppMain />} /> */}
                {/* <Route path="/appbundle" element={<AppCreation />} /> */}
                <Route path="/logs/pricing" element={<Log title={"Price_rating_log"} />} />
              </Route>
            </Route>
          </Routes>
        </BrowserRouter>
      </TotalDriverProvider>

    </AuthProvider>
  );
}

export default App;
